import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const EmbedStep = ({ number, description, isLast, children }) => {
  const theme = useTheme()

  return (
    <Styles.Container>
      <Styles.Indicator>
        <Styles.Number>
          <Text type="titleM" color={theme.colors.accent.default}>
            {number}
          </Text>
        </Styles.Number>
        {!isLast && <Styles.Connector />}
      </Styles.Indicator>
      <Styles.Content>
        <Text type="bodyMRegular">{description}</Text>
        {children}
      </Styles.Content>
    </Styles.Container>
  )
}

export default EmbedStep
